var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0B966B",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.813 11.333h4.125M15.813 11.333h1.374M21.313 6H.688M19.938 15.333H2.063c-.76 0-1.376-.597-1.376-1.333V2c0-.736.617-1.333 1.375-1.333h17.875c.76 0 1.375.597 1.375 1.333v12c0 .736-.616 1.333-1.375 1.333z"
  }))));
}
export default SvgIconCreditCard;